"use client";

import type { Animal } from "@/lib/types";

import { Activity, Scale, Users, Zap } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function StatisticsCards({ animals }: { animals: Animal[] }) {
  // Calculate statistics
  const totalAnimals = animals.length;
  // const activeAnimals = animals.filter((animal) => animal.animalStatus ===
  // "active").length

  // Calculate average weight
  const totalWeight = animals.reduce((sum, animal) => sum + animal.weight, 0);
  const averageWeight = totalAnimals > 0 ? totalWeight / totalAnimals : 0;

  // Calculate average ADG (Average Daily Gain)
  const totalADG = animals.reduce((sum, animal) => sum + animal.adg, 0);
  const averageADG = totalAnimals > 0 ? totalADG / totalAnimals : 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 z-100">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[#008c8fff]">
            Total Animals
          </CardTitle>
          <Users className="h-4 w-4 text-[#cfc130ff]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[#015354ff]">
            {totalAnimals}
          </div>
          {/* <p className="text-xs text-muted-foreground"> */}
          {/*   {activeAnimals} active ( */}
          {/*   {((activeAnimals / totalAnimals) * 100).toFixed(0)}%) */}
          {/* </p> */}
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[#008c8fff]">
            Average Weight
          </CardTitle>
          <Scale className="h-4 w-4 text-[#cfc130ff]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[#015354ff]">
            {averageWeight.toFixed(1)} kg
          </div>
          <p className="text-xs text-muted-foreground">Across all animals</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[#008c8fff]">
            Average ADG
          </CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground text-[#cfc130ff]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[#015354ff]">
            {averageADG.toFixed(2)} g/day
          </div>
          <p className="text-xs text-muted-foreground">Average daily gain</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[#008c8fff]">
            Efficiency Index
          </CardTitle>
          <Zap className="h-4 w-4 text-[#cfc130ff]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[#015354ff]">
            {(
              animals.reduce((sum, animal) => sum + animal.indexEfficiency, 0) /
              totalAnimals
            ).toFixed(2)}
          </div>
          <p className="text-xs text-[#015354ff]">Average across herd</p>
        </CardContent>
      </Card>
    </div>
  );
}
